import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { format, subDays } from "date-fns";
import { Grid } from "@mui/material";
import MetricValue from "../../metrics/metric-value";
import MetricTrend from "../../metrics/metric-trend";
import MetricPartition from "../../metrics/metric-partition";
import { getTrendLabels, getLabels } from "../../../../helpers/metrics";
import { useApiTenant } from "../../../../api/api-tenant";
import { metricColors } from "../../../../helpers/colors";
export default function TicketsMetricsGeneral({ type, group_id, contact_id, user_id, campaign, globalRange, setGlobalRange, globalStartDate, globalStartTime, globalEndDate, globalEndTime, isChosenGlobalCustomRange, setIsChosenGlobalCustomRange, }) {
    const { t } = useTranslation();
    const api = useApiTenant();
    const ref = useRef(null);
    const [ticketsValue, setTicketsValue] = useState(0);
    const [ticketsValueCachedAt, setTicketsValueCachedAt] = useState("");
    const [ticketsValueError, setTicketsValueError] = useState(false);
    const [ticketsValueRange, setTicketsValuesRange] = useState("total");
    const [ticketsValueLoading, setTicketsValueLoading] = useState(true);
    const [ticketsValueStartDate, setTicketsValueStartDate] = useState("");
    const [ticketsValueEndDate, setTicketsValueEndDate] = useState("");
    const [ticketsValueStartTime, setTicketsValueStartTime] = useState("");
    const [ticketsValueEndTime, setTicketsValueEndTime] = useState("");
    const [isChosenValueCustomRange, setIsChosenValueCustomRange] = useState(false);
    const [ticketsValueChosenStatuses, setTicketsValueChosenStatuses] = useState([]);
    const [ticketsValueChosenPriorities, setTicketsValueChosenPriorities] = useState([]);
    const [ticketsTrendLabels, setTicketsTrendLabels] = useState([]);
    const [ticketsTrendError, setTicketsTrendError] = useState(false);
    const [ticketsTrendValues, setTicketsTrendValues] = useState([]);
    const [ticketsTrendCachedAt, setTicketsTrendCachedAt] = useState("");
    const [ticketsTrendRange, setTicketsTrendRange] = useState("last_30_days");
    const [ticketsTrendLoading, setTicketsTrendLoading] = useState(true);
    const [ticketsTrendChosenStatuses, setTicketsTrendChosenStatuses] = useState([]);
    const [ticketsTrendChosenPriorities, setTicketsTrendChosenPriorities] = useState([]);
    const [ticketsStatusCachedAt, setTicketsStatusCachedAt] = useState("");
    const [ticketStatusData, setTicketStatusData] = useState([]);
    const [ticketStatusError, setTicketStatusError] = useState(false);
    const [ticketStatusRange, setTicketStatusRange] = useState("total");
    const [ticketStatusLoading, setTicketStatusLoading] = useState(true);
    const [ticketsStatusStartDate, setTicketsStatusStartDate] = useState("");
    const [ticketsStatusEndDate, setTicketsStatusEndDate] = useState("");
    const [ticketsStatusStartTime, setTicketsStatusStartTime] = useState("");
    const [ticketsStatusEndTime, setTicketsStatusEndTime] = useState("");
    const [ticketsStatusChosenPriorities, setTicketsStatusChosenPriorities] = useState([]);
    const [isChosenStatusCustomRange, setIsChosenStatusCustomRange] = useState(false);
    const [ticketsPriorityData, setTicketsPriorityData] = useState([]);
    const [ticketsPriorityError, setTicketsPriorityError] = useState(false);
    const [ticketsPriorityCachedAt, setTicketsPriorityCachedAt] = useState("");
    const [ticketsPriorityRange, setTicketsPriorityRange] = useState("total");
    const [ticketsPriorityStartDate, setTicketsPriorityStartDate] = useState("");
    const [ticketsPriorityEndDate, setTicketsPriorityEndDate] = useState("");
    const [ticketsPriorityStartTime, setTicketsPriorityStartTime] = useState("");
    const [ticketsPriorityEndTime, setTicketsPriorityEndTime] = useState("");
    const [isChosenPriorityCustomRange, setIsChosenPriorityCustomRange] = useState(false);
    const [ticketsPriorityLoading, setTicketsPriorityLoading] = useState(true);
    const [ticketsPriorityChosenStatuses, setTicketsPriorityChosenStatuses] = useState([]);
    const [ticketsValueMetricsRefresh, setTicketsValueMetricsRefresh] = useState(false);
    const [ticketsTrendMetricsRefresh, setTicketsTrendMetricsRefresh] = useState(false);
    const [ticketsStatusMetricsRefresh, setTicketsStatusMetricsRefresh] = useState(false);
    const [ticketsPriorityMetricsRefresh, setTicketsPriorityMetricsRefresh] = useState(false);
    const getTicketsValue = invalidateCache => {
        setTicketsValueLoading(true);
        if (ticketsValueError)
            setTicketsValueError(false);
        let startTime;
        let endTime;
        if (ticketsValueRange === "custom" &&
            ticketsValueStartDate !== "" &&
            ticketsValueEndDate !== "") {
            if (ticketsValueStartTime !== "") {
                startTime =
                    format(new Date(ticketsValueStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsValueStartTime), "HH:mm:ss");
            }
            else {
                startTime = format(new Date(ticketsValueStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (ticketsValueEndTime !== "") {
                endTime =
                    format(new Date(ticketsValueEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsValueEndTime), "HH:mm") +
                        ":59";
            }
            else {
                endTime = format(new Date(ticketsValueEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("count", "tickets", ticketsValueRange, type === "contact" ? "contact_id" : type === "campaign" ? "campaign_id" : undefined, type === "contact" ? contact_id : type === "campaign" ? campaign.id : undefined, type === "group"
            ? "groups,is_draft"
            : type === "user"
                ? "created_by,is_draft"
                : type === "campaign_group"
                    ? "campaign_id,is_draft,groups"
                    : "is_draft", type === "group"
            ? group_id + ",0"
            : type === "user"
                ? user_id + ",0"
                : type === "campaign_group"
                    ? campaign.id + ",0," + group_id
                    : "0", type === "campaign_group" || type === "group" ? 1 : undefined, invalidateCache ? 1 : undefined, ticketsValueRange === "custom" ? startTime : undefined, ticketsValueRange === "custom" ? endTime : undefined, undefined, undefined, campaign && ticketsValueChosenStatuses.length > 0
            ? ticketsValueChosenStatuses.map(i => i.id)
            : undefined, campaign && ticketsValueChosenPriorities.length > 0
            ? ticketsValueChosenPriorities.map(i => i.id)
            : undefined)
            .then(response => {
            setTicketsValue(response.data.count);
            setTicketsValueCachedAt(response.data.cached_at);
            setTicketsValueLoading(false);
        })
            .catch(error => {
            setTicketsValueError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketsValueLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getTicketsTrendValues = invalidateCache => {
        setTicketsTrendLoading(true);
        if (ticketsTrendError)
            setTicketsTrendError(false);
        let trendsLabels = getTrendLabels(ticketsTrendRange);
        let labels = getLabels(trendsLabels, ticketsTrendRange);
        setTicketsTrendLabels(labels);
        let interval = ticketsTrendRange;
        let startDate;
        let endDate;
        if (ticketsTrendRange === "last_7_days") {
            interval = "custom";
            startDate = format(subDays(new Date(), 6), "yyyy-MM-dd") + " 00:00:00";
            endDate = format(new Date(), "yyyy-MM-dd") + " 23:59:59";
        }
        else if (ticketsTrendRange === "last_30_days") {
            interval = "custom";
            startDate = format(subDays(new Date(), 29), "yyyy-MM-dd") + " 00:00:00";
            endDate = format(new Date(), "yyyy-MM-dd") + " 23:59:59";
        }
        api.GET_metrics("trend", "tickets", interval, undefined, undefined, type === "group"
            ? "groups,is_draft"
            : type === "user"
                ? "created_by,is_draft"
                : type === "campaign"
                    ? "campaign_id,is_draft"
                    : type === "campaign_group"
                        ? "campaign_id,is_draft,groups"
                        : type === "contact"
                            ? "contact_id,is_draft"
                            : "is_draft", type === "group"
            ? group_id + ",0"
            : type === "user"
                ? user_id + ",0"
                : type === "campaign"
                    ? campaign.id + ",0"
                    : type === "campaign_group"
                        ? campaign.id + ",0," + group_id
                        : type === "contact"
                            ? contact_id + ",0"
                            : "0", type === "group" || type === "campaign_group" ? 1 : undefined, invalidateCache ? 1 : undefined, startDate, endDate, undefined, undefined, campaign && ticketsTrendChosenStatuses.length > 0
            ? ticketsTrendChosenStatuses.map(i => i.id)
            : undefined, campaign && ticketsTrendChosenPriorities.length > 0
            ? ticketsTrendChosenPriorities.map(i => i.id)
            : undefined)
            .then(response => {
            let values = [];
            trendsLabels.map(label => {
                if (response.data.data.find(a => a.date === label)) {
                    values.push(response.data.data.find(a => a.date === label).count);
                }
                else {
                    values.push(0);
                }
            });
            setTicketsTrendCachedAt(response.data.cached_at);
            setTicketsTrendValues(values);
            setTicketsTrendLoading(false);
        })
            .catch(error => {
            setTicketsTrendError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketsTrendLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getTicketsStatusValues = invalidateCache => {
        setTicketStatusLoading(true);
        if (ticketStatusError)
            setTicketStatusError(false);
        let startTime;
        let endTime;
        if (ticketStatusRange === "custom" &&
            ticketsStatusStartDate !== "" &&
            ticketsStatusEndDate !== "") {
            if (ticketsStatusStartTime !== "") {
                startTime =
                    format(new Date(ticketsStatusStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsStatusStartTime), "HH:mm:ss");
            }
            else {
                startTime = format(new Date(ticketsStatusStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (ticketsStatusEndTime !== "") {
                endTime =
                    format(new Date(ticketsStatusEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsStatusEndTime), "HH:mm") +
                        ":59";
            }
            else {
                endTime = format(new Date(ticketsStatusEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("partition", "tickets", ticketStatusRange, "ticketDetail.status", undefined, type === "campaign"
            ? "campaign,is_draft"
            : type === "campaign_group"
                ? "campaign,groups,is_draft"
                : "is_draft", type === "campaign"
            ? campaign.id + "," + 0
            : type === "campaign_group"
                ? campaign.id + "," + group_id + "," + 0
                : "0", type === "campaign_group" ? 1 : undefined, invalidateCache ? 1 : undefined, ticketStatusRange === "custom" ? startTime : undefined, ticketStatusRange === "custom" ? endTime : undefined, undefined, undefined, undefined, campaign && ticketsStatusChosenPriorities.length > 0
            ? ticketsStatusChosenPriorities.map(i => i.id)
            : undefined)
            .then(response => {
            let metricsData = [];
            let colorIndex = 0;
            response.data.data
                .sort((a, b) => a.label.localeCompare(b.label))
                .sort((a, b) => a.count - b.count)
                .reverse()
                .map(d => {
                metricsData.push({
                    label: d.label,
                    count: d.count,
                    color: metricColors[colorIndex],
                });
                if (colorIndex + 1 === metricColors.length) {
                    colorIndex = 0;
                }
                else {
                    colorIndex++;
                }
            });
            setTicketStatusData(metricsData);
            setTicketsStatusCachedAt(response.data.cached_at);
            setTicketStatusLoading(false);
        })
            .catch(error => {
            setTicketStatusError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketStatusLoading(false);
            }
            setTicketStatusError(true);
        });
        return () => api.cancel();
    };
    const getTicketsPriorityValues = invalidateCache => {
        setTicketsPriorityLoading(true);
        if (ticketsPriorityError)
            setTicketsPriorityError(false);
        let startTime;
        let endTime;
        if (ticketsPriorityRange === "custom" &&
            ticketsPriorityStartDate !== "" &&
            ticketsPriorityEndDate !== "") {
            if (ticketsPriorityStartTime !== "") {
                startTime =
                    format(new Date(ticketsPriorityStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsPriorityStartTime), "HH:mm:ss");
            }
            else {
                startTime = format(new Date(ticketsPriorityStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (ticketsPriorityEndTime !== "") {
                endTime =
                    format(new Date(ticketsPriorityEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsPriorityEndTime), "HH:mm") +
                        ":59";
            }
            else {
                endTime = format(new Date(ticketsPriorityEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("partition", "tickets", ticketsPriorityRange, "ticketDetail.priority", undefined, type === "campaign"
            ? "campaign,is_draft"
            : type === "campaign_group"
                ? "campaign,is_draft,groups"
                : "is_draft", type === "campaign"
            ? campaign.id + ",0"
            : type === "campaign_group"
                ? campaign.id + ",0," + group_id
                : "0", type === "campaign_group" ? 1 : undefined, invalidateCache ? 1 : undefined, ticketsPriorityRange === "custom" ? startTime : undefined, ticketsPriorityRange === "custom" ? endTime : undefined, undefined, undefined, campaign && ticketsPriorityChosenStatuses.length > 0
            ? ticketsPriorityChosenStatuses.map(i => i.id)
            : undefined, undefined)
            .then(response => {
            let metricsData = [];
            let colorIndex = 0;
            response.data.data
                .sort((a, b) => a.label.localeCompare(b.label))
                .sort(function (a, b) {
                return a.count - b.count;
            })
                .reverse()
                .map(a => {
                metricsData.push({
                    label: a.label,
                    count: a.count,
                    color: metricColors[colorIndex],
                });
                if (colorIndex + 1 === metricColors.length) {
                    colorIndex = 0;
                }
                else {
                    colorIndex++;
                }
            });
            setTicketsPriorityData(metricsData);
            setTicketsPriorityCachedAt(response.data.cached_at);
            setTicketsPriorityLoading(false);
        })
            .catch(error => {
            setTicketsPriorityError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketsPriorityLoading(false);
            }
        });
        return () => api.cancel();
    };
    useEffect(() => {
        if (ticketsValueRange !== "custom") {
            setTicketsValueStartDate("");
            setTicketsValueEndDate("");
            setTicketsValueStartTime("");
            setTicketsValueEndTime("");
            getTicketsValue(undefined);
        }
    }, [ticketsValueRange]);
    useEffect(() => {
        getTicketsTrendValues(undefined);
    }, [ticketsTrendRange]);
    useEffect(() => {
        if (ticketStatusRange !== "custom") {
            setTicketsStatusStartDate("");
            setTicketsStatusEndDate("");
            setTicketsStatusStartTime("");
            setTicketsStatusEndTime("");
            getTicketsStatusValues(undefined);
        }
    }, [ticketStatusRange]);
    useEffect(() => {
        if (ticketsPriorityRange !== "custom") {
            setTicketsPriorityStartDate("");
            setTicketsPriorityEndDate("");
            setTicketsPriorityStartTime("");
            setTicketsPriorityEndTime("");
            getTicketsPriorityValues(undefined);
        }
    }, [ticketsPriorityRange]);
    useEffect(() => {
        if (globalRange &&
            setGlobalRange &&
            globalRange !== "none" &&
            (ticketsValueRange !== globalRange ||
                (ticketsValueRange === globalRange &&
                    (globalStartDate !== ticketsValueStartDate ||
                        globalStartTime !== ticketsValueStartTime ||
                        globalEndDate !== ticketsValueEndDate ||
                        globalEndTime !== ticketsValueEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenValueCustomRange &&
            ticketsValueStartDate !== "" &&
            ticketsValueEndDate !== "") {
            getTicketsValue(undefined);
            setIsChosenValueCustomRange(false);
        }
    }, [isChosenValueCustomRange]);
    useEffect(() => {
        if (globalRange &&
            setGlobalRange &&
            globalRange !== "none" &&
            (ticketStatusRange !== globalRange ||
                (ticketStatusRange === globalRange &&
                    (globalStartDate !== ticketsStatusStartDate ||
                        globalStartTime !== ticketsStatusStartTime ||
                        globalEndDate !== ticketsStatusEndDate ||
                        globalEndTime !== ticketsStatusEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenStatusCustomRange &&
            ticketsStatusStartDate !== "" &&
            ticketsStatusEndDate !== "") {
            getTicketsStatusValues(undefined);
            setIsChosenStatusCustomRange(false);
        }
    }, [isChosenStatusCustomRange]);
    useEffect(() => {
        if (globalRange &&
            setGlobalRange &&
            globalRange !== "none" &&
            (ticketsPriorityRange !== globalRange ||
                (ticketsPriorityRange === globalRange &&
                    (globalStartDate !== ticketsPriorityStartDate ||
                        globalStartTime !== ticketsPriorityStartTime ||
                        globalEndDate !== ticketsPriorityEndDate ||
                        globalEndTime !== ticketsPriorityEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenPriorityCustomRange &&
            ticketsPriorityStartDate !== "" &&
            ticketsPriorityEndDate !== "") {
            getTicketsPriorityValues(undefined);
            setIsChosenPriorityCustomRange(false);
        }
    }, [isChosenPriorityCustomRange]);
    useEffect(() => {
        if (ticketsValueChosenStatuses.length !== 0 || ticketsValueChosenPriorities.length !== 0)
            getTicketsValue(false);
    }, [ticketsValueChosenStatuses.length, ticketsValueChosenPriorities.length]);
    useEffect(() => {
        if (ticketsTrendChosenStatuses.length !== 0 || ticketsTrendChosenPriorities.length !== 0)
            getTicketsTrendValues(false);
    }, [ticketsTrendChosenStatuses.length, ticketsTrendChosenPriorities.length]);
    useEffect(() => {
        if (ticketsStatusChosenPriorities.length !== 0)
            getTicketsStatusValues(false);
    }, [ticketsStatusChosenPriorities.length]);
    useEffect(() => {
        if (ticketsPriorityChosenStatuses.length !== 0)
            getTicketsPriorityValues(false);
    }, [ticketsPriorityChosenStatuses.length]);
    useEffect(() => {
        if (ticketsValueMetricsRefresh) {
            getTicketsValue(true);
            setTicketsValueMetricsRefresh(false);
        }
        else if (ticketsTrendMetricsRefresh) {
            getTicketsTrendValues(true);
            setTicketsTrendMetricsRefresh(false);
        }
        else if (ticketsStatusMetricsRefresh) {
            getTicketsStatusValues(true);
            setTicketsStatusMetricsRefresh(false);
        }
        else if (ticketsPriorityMetricsRefresh) {
            getTicketsPriorityValues(true);
            setTicketsPriorityMetricsRefresh(false);
        }
    }, [
        ticketsValueMetricsRefresh,
        ticketsTrendMetricsRefresh,
        ticketsStatusMetricsRefresh,
        ticketsPriorityMetricsRefresh,
    ]);
    useEffect(() => {
        if (globalRange && globalRange !== "none" && globalRange !== "custom") {
            if (ticketsValueRange !== globalRange ||
                (ticketsTrendRange !== globalRange &&
                    globalRange !== "day" &&
                    globalRange !== "yesterday" &&
                    globalRange !== "total") ||
                ticketStatusRange !== globalRange ||
                ticketsPriorityRange !== globalRange) {
                setTicketsValuesRange(globalRange);
                if (globalRange !== "day" &&
                    globalRange !== "yesterday" &&
                    globalRange !== "total") {
                    setTicketsTrendRange(globalRange);
                }
                setTicketStatusRange(globalRange);
                setTicketsPriorityRange(globalRange);
            }
        }
    }, [globalRange]);
    useEffect(() => {
        if (isChosenGlobalCustomRange &&
            setIsChosenGlobalCustomRange &&
            globalRange &&
            globalRange === "custom" &&
            globalStartDate &&
            globalStartDate !== "" &&
            globalEndDate &&
            globalEndDate !== "") {
            setTicketsValueStartDate(globalStartDate);
            setTicketsValueEndDate(globalEndDate);
            setTicketsStatusStartDate(globalStartDate);
            setTicketsStatusEndDate(globalEndDate);
            setTicketsPriorityStartDate(globalStartDate);
            setTicketsPriorityEndDate(globalEndDate);
            setTicketsValueStartTime(globalStartTime ? globalStartTime : "");
            setTicketsStatusStartTime(globalStartTime ? globalStartTime : "");
            setTicketsPriorityStartTime(globalStartTime ? globalStartTime : "");
            setTicketsValueEndTime(globalEndTime ? globalEndTime : "");
            setTicketsStatusEndTime(globalEndTime ? globalEndTime : "");
            setTicketsPriorityEndTime(globalEndTime ? globalEndTime : "");
            setTicketsValuesRange(globalRange);
            setTicketStatusRange(globalRange);
            setTicketsPriorityRange(globalRange);
            setIsChosenValueCustomRange(true);
            setIsChosenStatusCustomRange(true);
            setIsChosenPriorityCustomRange(true);
            setIsChosenGlobalCustomRange(false);
        }
    }, [isChosenGlobalCustomRange]);
    return (_jsxs(Grid, Object.assign({ container: true, spacing: 4, width: "100%", marginLeft: "0px", paddingTop: "32px", ref: ref }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, xl: 4 }, { children: _jsx(MetricValue, { title: t("tickets.tickets"), value: ticketsValue, range: ticketsValueRange, setRange: setTicketsValuesRange, isLoading: ticketsValueLoading, setIsLoading: setTicketsValueLoading, cachedAt: ticketsValueCachedAt, refresh: ticketsValueMetricsRefresh, setRefresh: setTicketsValueMetricsRefresh, startDate: ticketsValueStartDate, setStartDate: setTicketsValueStartDate, endDate: ticketsValueEndDate, setEndDate: setTicketsValueEndDate, startTime: ticketsValueStartTime, setStartTime: setTicketsValueStartTime, endTime: ticketsValueEndTime, setEndTime: setTicketsValueEndTime, globalRange: globalRange, setGlobalRange: setGlobalRange, setIsChosenCustomRange: setIsChosenValueCustomRange, isError: ticketsValueError, statuses: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenStatuses: campaign ? ticketsValueChosenStatuses : undefined, setChosenStatuses: campaign ? setTicketsValueChosenStatuses : undefined, chosenPriorities: campaign ? ticketsValueChosenPriorities : undefined, setChosenPriorities: campaign ? setTicketsValueChosenPriorities : undefined }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, xl: 8 }, { children: _jsx(MetricTrend, { title: t("tickets.metrics.tickets-trend"), label: t("tickets.tickets"), labels: ticketsTrendLabels, values: ticketsTrendValues, range: ticketsTrendRange, setRange: setTicketsTrendRange, isLoading: ticketsTrendLoading, setIsLoading: setTicketsTrendLoading, cachedAt: ticketsTrendCachedAt, refresh: ticketsTrendMetricsRefresh, setRefresh: setTicketsTrendMetricsRefresh, isError: ticketsTrendError, statuses: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenStatuses: campaign ? ticketsTrendChosenStatuses : undefined, setChosenStatuses: campaign ? setTicketsTrendChosenStatuses : undefined, chosenPriorities: campaign ? ticketsTrendChosenPriorities : undefined, setChosenPriorities: campaign ? setTicketsTrendChosenPriorities : undefined }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, xl: 8 }, { children: _jsx(MetricPartition, { title: t("tickets.metrics.tickets-status"), range: ticketStatusRange, setRange: setTicketStatusRange, isLoading: ticketStatusLoading, setIsLoading: setTicketStatusLoading, cachedAt: ticketsStatusCachedAt, refresh: ticketsStatusMetricsRefresh, setRefresh: setTicketsStatusMetricsRefresh, startDate: ticketsStatusStartDate, setStartDate: setTicketsStatusStartDate, endDate: ticketsStatusEndDate, setEndDate: setTicketsStatusEndDate, startTime: ticketsStatusStartTime, setStartTime: setTicketsStatusStartTime, endTime: ticketsStatusEndTime, setEndTime: setTicketsStatusEndTime, globalRange: globalRange, setGlobalRange: setGlobalRange, setIsChosenCustomRange: setIsChosenStatusCustomRange, metricData: ticketStatusData, type: type, metricType: "status", isError: ticketStatusError, statuses: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenPriorities: campaign ? ticketsStatusChosenPriorities : undefined, setChosenPriorities: campaign ? setTicketsStatusChosenPriorities : undefined }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 6, xl: 4 }, { children: _jsx(MetricPartition, { title: t("tickets.metrics.tickets-priority"), range: ticketsPriorityRange, setRange: setTicketsPriorityRange, isLoading: ticketsPriorityLoading, setIsLoading: setTicketsPriorityLoading, cachedAt: ticketsPriorityCachedAt, refresh: ticketsPriorityMetricsRefresh, setRefresh: setTicketsPriorityMetricsRefresh, startDate: ticketsPriorityStartDate, setStartDate: setTicketsPriorityStartDate, endDate: ticketsPriorityEndDate, setEndDate: setTicketsPriorityEndDate, startTime: ticketsPriorityStartTime, setStartTime: setTicketsPriorityStartTime, endTime: ticketsPriorityEndTime, setEndTime: setTicketsPriorityEndTime, globalRange: globalRange, setGlobalRange: setGlobalRange, setIsChosenCustomRange: setIsChosenPriorityCustomRange, metricData: ticketsPriorityData, type: type, metricType: "priority", isError: ticketsPriorityError, statuses: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenStatuses: campaign ? ticketsPriorityChosenStatuses : undefined, setChosenStatuses: campaign ? setTicketsPriorityChosenStatuses : undefined }) }))] })));
}
